let html = `<div class="full-person selector layer--visible">
    <div class="full-person__photo">
        <img />
    </div>

    <div class="full-person__body">
        <div class="full-person__name">{name}</div>
        <div class="full-person__role">{role}</div>
    </div>
</div>`

export default html